export { default, default as SharedResources } from "./SharedResources";
